import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export default function LayoutSection(props) {
  var _props$content;
  var isAdvancedLayoutsPreRelease2 = editorExperiment('advanced_layouts', true) || fg('platform_editor_advanced_layouts_pre_release_2');
  return isAdvancedLayoutsPreRelease2 ?
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  React.createElement("div", {
    className: "layout-section-container"
  }, /*#__PURE__*/React.createElement("div", {
    "data-layout-section": true,
    "data-layout-columns": props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
  }, props.children)) : /*#__PURE__*/React.createElement("div", {
    "data-layout-section": true
  }, props.children);
}